export var isExternalLinkEntityData = function isExternalLinkEntityData(entityData) {
  return entityData.url !== undefined;
};
export var isInternalLinkEntityData = function isInternalLinkEntityData(entityData) {
  return entityData.contentId !== undefined;
};
export var isAffiliationLinkEntityData = function isAffiliationLinkEntityData(entityData) {
  return entityData.productName !== undefined;
};